import { Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { FiEdit, FiEye, FiTrash, FiUserCheck, FiUserX } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { api, endpoint } from '../../api';
import moment from 'moment'
import Swal from 'sweetalert2';

const Dial = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [dialList, setDialList] = useState([]);
    const [successMessage, setSuccessMessage] = useState('')
    const [errorMessage, setErrorMessage] = useState('')

    const getDialList = async () => {
        setIsLoading(true)
        try {
            const { results, success } = await api.get(endpoint.dial)
            if (success) {
                setDialList(results)
            }
        } catch (error) {
            console.log(error)
        }
        setIsLoading(false)
    }

    const handleDelete = async (id) => {
        setIsLoading(true)
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You want to remove a dial?",
            //icon: "warning",
            dangerMode: true,
            showCancelButton: true,
            confirmButtonText: "Confirm",
        })

        if (result.isConfirmed) {
            try {
                const { success } = await api.delete(endpoint.dial + '/' + id)
                if (success) {
                    setSuccessMessage('Dial Deleted Successfully')
                    getDialList()
                }
            } catch (error) {
                setErrorMessage(error.message || 'Some Error Occurred')
            }
        }

        setIsLoading(false)
        setTimeout(() => {
            setErrorMessage('');
            setSuccessMessage('')
        }, 2000);
    }

    useEffect(() => {
        getDialList()
    }, [])


    const columns = [
        {
            name: 'No.',
            selector: ((data, ind) => ind + 1),
            width: '60px',
        },

        {
            name: 'Title',
            cell: (row) => row.title,
        },

        {
            name: 'Date Created',
            selector: (row) => moment(row.createdAt).format('DD/MM/YYYY'),
            center: true,
        },

        // {
        //     name: 'Status',
        //     cell: (row) => (
        //         <div>
        //             {row.isActive ? (
        //                 <span className="badge text-bg-success">Active</span>
        //             ) : (
        //                 <span className="badge text-bg-danger">Deactivated</span>
        //             )}
        //         </div>
        //     ),
        //     center: true,
        //     // width: '100px',
        // },
        {
            name: 'Action',
            width: '220px',
            center: true,
            cell: (row) => (
                <div>
                    <Link to={`/dial/${row._id}`} className="btn btn-success me-1">
                        <FiEye title="View Profile" />
                    </Link>
                    <Link to={`/dial/edit/${row._id}`} className="btn btn-info me-1">
                        <FiEdit title="Edit Profile" />
                    </Link>
                    <button className="btn btn-danger" onClick={() => handleDelete(row._id)}>
                        <FiTrash title="Delete" />
                    </button>
                </div>
            ),
        },
    ];




    return (
        <div className="card p-3 m-3">
            {errorMessage && (
                <div className="alert alert-danger" role="alert">
                    {errorMessage}{" "}
                </div>
            )}

            {successMessage && (
                <div className="alert alert-success" role="alert">
                    {successMessage}{" "}
                </div>
            )}

            <div className="d-flex align-items-center justify-content-between">
                <div>
                    <label className="az-content-label">Manage Dial</label>
                    <span className="d-block py-2">Dial List</span>
                </div>
                <div className="col-md-4 d-flex justify-content-end p-0">
                    <Link className="btn btn-az-primary btn-md text-capitalize" to={`/dial/create'}`}>
                        Add Dial
                    </Link>
                </div>
            </div>
            <Spin spinning={isLoading}>
                <DataTable
                    columns={columns}
                    data={dialList}
                    pagination
                    paginationServer
                    noDataComponent={isLoading ? 'Loading' : 'No record found.'}
                    className="mt-3"
                    // paginationTotalRows={total}
                    // paginationPerPage={limit}
                    // onChangePage={(data) => {
                    //     setPage(data);
                    // }}
                    // onChangeRowsPerPage={(data) => {
                    //     setLimit(data);
                    //     setPage(1);
                    // }}
                    paginationRowsPerPageOptions={[10, 20, 50]}
                />
            </Spin>
        </div>
    );
};

export default Dial;